import React from "react";
import { Input } from "antd";

const InputCep = ({ value, onChange, ...props }) => {
	const formatCep = (value) => {
		if (!value) return "";

		// Remove tudo que não é dígito
		const numbers = value.replace(/\D/g, "");

		// Aplica a máscara do CEP (00000-000)
		if (numbers.length <= 5) {
			return numbers;
		} else {
			return `${numbers.slice(0, 5)}-${numbers.slice(5, 8)}`;
		}
	};

	const handleChange = (e) => {
		const formattedValue = formatCep(e.target.value);
		if (onChange) {
			onChange({
				...e,
				target: {
					...e.target,
					value: formattedValue,
				},
			});
		}
	};

	return (
		<Input
			{...props}
			value={value}
			onChange={handleChange}
			maxLength={9}
			placeholder="00000-000"
		/>
	);
};

export const cepValidator = (_, value) => {
	if (!value || value.trim() === "") {
		return Promise.resolve();
	}

	const cepNumbers = value.replace(/\D/g, "");
	if (cepNumbers.length !== 8) {
		return Promise.reject(new Error("CEP deve conter 8 dígitos"));
	}

	return Promise.resolve();
};

export default InputCep;
